import axios from "axios";
import config from "@/router/globalConfig";

export default {

 SetBannerImage(_data_) {
        return axios.post(config.WEB_API_PATH + 'Cms/SetBannerImage', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },

    DeleteBannerImage(_data_) {
        return axios.post(config.WEB_API_PATH + 'Cms/DeleteBannerImage', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    GetBannerImage(_data_) {
        return axios.get(config.WEB_API_PATH + 'Cms/GetBannerImage', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    SetPhotoGallery(_data_) {
        return axios.post(config.WEB_API_PATH + 'Cms/SetPhotoGallery', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    GetPhotoGallery(_data_) {
        return axios.get(config.WEB_API_PATH + 'Cms/GetPhotoGallery', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    deletePhotoGalleryImage(_data_) {
        return axios.post(config.WEB_API_PATH + 'Cms/DeletePhotoGallery', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    SetVideoGallery(_data_) {
        return axios.post(config.WEB_API_PATH + 'Cms/SetVideoGallery', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    GetVideoGallery(_data_) {
        return axios.get(config.WEB_API_PATH + 'Cms/GetVideoGallery', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    DeleteVideoGallery(_data_) {
        return axios.post(config.WEB_API_PATH + 'Cms/DeleteVideoGallery', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    setPopUpImage(_data_) {
        return axios.post(config.WEB_API_PATH + 'Cms/SetPopupImage', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
    getPopupImage(_data_) {
        return axios.get(config.WEB_API_PATH + 'Cms/GetPopupImage', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    DeletePopupImage(_data_) {
        return axios.post(config.WEB_API_PATH + 'Cms/DeletePopupImage', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
        });
    },
}


// WEBPACK FOOTER //
// ./src/components/servicesJS/CMS.js